import LeadForm from "./LeadForm";
import { WHATSAPP_URL, trackWhatsAppClick } from "@/lib/constants";
import { MessageCircle } from "lucide-react";

export default function BottomCTA() {
  return (
    <section data-testid="bottom-cta-section" className="relative py-16 sm:py-20 overflow-hidden">
      {/* Background with real stairlift image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://vingrace.in/wp-content/uploads/2025/12/Otolift-Modul-Air-Curved-Chair-Lift-1024x1024.webp"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-900/95 via-stone-900/90 to-stone-900/70" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left Text */}
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-amber-400 mb-4">Get Started Today</p>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-white font-['Outfit']">
              Ready to Redefine Mobility<br />in Your Home?
            </h2>
            <p className="mt-4 text-stone-300 leading-relaxed max-w-md">
              Get a free home survey and personalized stairlift quote. Prices start at just ₹1.55 Lakhs. Easy EMI options available. Join 8,000+ happy families across India.
            </p>
            <div className="mt-6">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="bottom-cta-whatsapp"
                onClick={trackWhatsAppClick}
                className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1da851] text-white rounded-xl px-6 py-3 font-semibold text-sm transition-colors"
              >
                <MessageCircle className="w-4 h-4" />
                WhatsApp Us
              </a>
            </div>
            <div className="mt-8 grid grid-cols-3 gap-6">
              <div>
                <p className="text-3xl font-bold text-white font-['Outfit']">17+</p>
                <p className="text-stone-400 text-sm mt-1">Years Experience</p>
              </div>
              <div>
                <p className="text-3xl font-bold text-white font-['Outfit']">8K+</p>
                <p className="text-stone-400 text-sm mt-1">Installations</p>
              </div>
              <div>
                <p className="text-3xl font-bold text-white font-['Outfit']">4.5</p>
                <p className="text-stone-400 text-sm mt-1">Google Rating</p>
              </div>
            </div>
          </div>

          {/* Right: Form */}
          <div>
            <LeadForm variant="bottom" />
          </div>
        </div>
      </div>
    </section>
  );
}
